import React from 'react';
import PropTypes from 'prop-types';
import { compose, setDisplayName, pure, setPropTypes } from 'recompose';

import { StyledBoxMessage, StyledMessageTitle, StyledIconRazor } from './style';
import { Razor } from '../../../../assets/images/index';

const Error = ({ code, message }) => (
  <StyledBoxMessage>
    <div>
      <StyledMessageTitle>
        {code}
        <span> Upps! Hubo un error </span>
      </StyledMessageTitle>
      <p>{message}</p>
    </div>
    <StyledIconRazor svg={Razor} />
  </StyledBoxMessage>
);

export default compose(
  setDisplayName('ErrorView'),
  setPropTypes({
    code: PropTypes.number,
    message: PropTypes.string
  }),
  pure
)(Error);
